import { api } from "./apiClient";

export const paymentService = {
  methods: async () => (await api.get("/payments/methods")).data,
  deposits: async () => (await api.get("/payments/deposits")).data,
  createDeposit: async (payload) => (await api.post("/payments/deposits", payload)).data,
  accounts: async () => (await api.get("/payments/accounts")).data,
  addAccount: async (payload) => (await api.post("/payments/accounts", payload)).data,
  deleteAccount: async (id) => (await api.delete(`/payments/accounts/${id}`)).data,
  withdrawals: async () => (await api.get("/payments/withdrawals")).data,
  createWithdrawal: async (payload) => (await api.post("/payments/withdrawals", payload)).data,
};

export const adminPaymentService = {
  methods: async () => (await api.get("/admin/payment-methods")).data,
  createMethod: async (payload) => (await api.post("/admin/payment-methods", payload)).data,
  updateMethod: async (id, payload) => (await api.patch(`/admin/payment-methods/${id}`, payload)).data,
  deleteMethod: async (id) => (await api.delete(`/admin/payment-methods/${id}`)).data,
  deposits: async (params = {}) => (await api.get("/admin/deposits", { params })).data,
  withdrawals: async (params = {}) => (await api.get("/admin/withdrawals", { params })).data,
  clearDeposits: async () => (await api.delete("/admin/deposits/history")).data,
  clearWithdrawals: async () => (await api.delete("/admin/withdrawals/history")).data,
  reviewDeposit: async (id, action) => (await api.post(`/admin/deposits/${id}/${action}`)).data,
  reviewWithdrawal: async (id, action) => (await api.post(`/admin/withdrawals/${id}/${action}`)).data,
};

export const managerService = {
  summary: async () => (await api.get("/manager/summary")).data,
  clients: async (params = {}) => (await api.get("/manager/clients", { params })).data,
  profile: async (id) => (await api.get(`/manager/clients/${id}/profile`)).data,
  comments: async (id) => (await api.get(`/manager/clients/${id}/comments`)).data,
  addComment: async (id, text) => (await api.post(`/manager/clients/${id}/comments`, { text })).data,
  resetPassword: async (id, password) => (await api.post(`/manager/clients/${id}/password`, { password })).data,
  setTier: async (id, account_tier, leverage_override = null) =>
    (await api.post(`/manager/clients/${id}/tier`, { account_tier, leverage_override })).data,
  positions: async (id) => (await api.get(`/manager/clients/${id}/positions`)).data,
  trades: async (id) => (await api.get(`/manager/clients/${id}/trades`)).data,
  tradingDetail: async (id) => (await api.get(`/manager/trading/clients/${id}`)).data,
  editPosition: async (id, payload) => (await api.patch(`/manager/trading/positions/${id}`, payload)).data,
  deposits: async () => (await api.get("/manager/deposits")).data,
  withdrawals: async () => (await api.get("/manager/withdrawals")).data,
  capabilities: async () => (await api.get("/manager/capabilities")).data,
  managers: async () => (await api.get("/manager/managers")).data,
  createManager: async (payload) => (await api.post("/manager/managers", payload)).data,
  hideClient: async (id) => (await api.post(`/manager/clients/${id}/hide`)).data,
  hideTeamMember: async (id) => (await api.post(`/manager/team/${id}/hide`)).data,
  agents: async () => (await api.get("/manager/agents")).data,
  createAgent: async (payload) => (await api.post("/manager/agents", payload)).data,
  createClient: async (payload) => (await api.post("/manager/clients", payload)).data,
  adjustBalance: async (id, amount, target, note, kind) =>
    (await api.post(`/manager/clients/${id}/balance`, { amount, target, note, kind })).data,
  reviewDeposit: async (id, action) => (await api.post(`/manager/deposits/${id}/${action}`)).data,
  reviewWithdrawal: async (id, action) => (await api.post(`/manager/withdrawals/${id}/${action}`)).data,
  teamMember: async (id) => (await api.get(`/manager/team/${id}`)).data,
};
